import { render, staticRenderFns } from "./InformalQuestions.vue?vue&type=template&id=44b58e52&scoped=true&"
import script from "./InformalQuestions.vue?vue&type=script&lang=js&"
export * from "./InformalQuestions.vue?vue&type=script&lang=js&"
import style0 from "./InformalQuestions.vue?vue&type=style&index=0&id=44b58e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b58e52",
  null
  
)

export default component.exports